module.exports = __webpack_public_path__ + "img/cart-icon.cf9b3149.svg";